import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventsService, PaymentV2Service, StorageService, UtilService, VariablesService } from '../../shared/services';
import { IPaymentSipConfig, SIP_PAYMENT_DEFAULT_CONFIG } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-option-v2',
  templateUrl: './payment-option-v2.component.html',
  styleUrls: ['./payment-option-v2.component.scss']
})
export class PaymentOptionV2Component implements OnInit, OnChanges, OnDestroy {

  @Input() inputs: IPaymentSipConfig;
  config: IPaymentSipConfig;
  paymentOptions;
  qprams;
  selectedTab;
  tabs = [
    { label: 'Previously Used', icon: 'star_outline', order_mode: 'PREVIOUSPAYMENTGATEWAY', name: 'pu', txt: '', title: '', icon_set: '' },
    { label: 'UPI', icon: 'contactless', order_mode: 'UPI', name: 'upi', txt: 'You need to have a registered UPI ID', title: 'Add New UPI', icon_set: 'TOPUPI' },
    { label: 'Card', icon: 'credit_card', order_mode: 'CARD', name: 'card', txt: 'Visa, Mastercard, Amex, RuPay & more', title: 'Add New Cards', icon_set: 'CARD' },
    { label: 'Net Banking', icon: 'account_balance', order_mode: 'NB', name: 'bank', txt: 'Select from a list of Banks', title: 'Internet Banking', icon_set: 'TOPNB' },
    { label: 'Paytm', icon: 'account_balance_wallet', order_mode: 'PAYTM', name: 'paytm', txt: '', title: '', icon_set: 'TOPWALLET' },
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    { label: 'Wallets', icon: 'account_balance_wallet', order_mode: 'WALLET', name: 'wallet', txt: 'Paytm, PhonePe, Amazon Pay & more', title: 'Wallets', icon_set: 'TOPWALLET' },
  ];
  options = [];
  recommendedOption;
  qrGenerated = false;
  subs: Subscription[] = [];
  submitData;
  isMobile;

  constructor(
    private router: Router,
    private actRoute: ActivatedRoute,
    public util: UtilService,
    public paymentV2: PaymentV2Service,
    public vars: VariablesService,
    public events: EventsService,
    private storageService: StorageService
  ) { }

  ngOnChanges(): void {
    this.setConfig(this.config);
  }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
    if (this.actRoute.snapshot.queryParams.st !== 'f') {
      this.util.router.navigate([], { queryParams: { method: null, method_type: null }, queryParamsHandling: 'merge' });
    }
    this.config = { ...SIP_PAYMENT_DEFAULT_CONFIG, ...this.config };
    this.config.one_time_donation = true;
    this.actRoute.queryParams.subscribe(res => this.qprams = res);
    this.subs.push(
      this.paymentV2.paymentConfig.subscribe((res) => {
        if (res?.cart) {
          this.setConfig({
            cart: res.cart,
            amount: res.cart.donated_amount,
            donateBtnLabel: `Pay <span class="amount-ot">${this.util.formatAmount(res.cart.donated_amount, this.config.currency)}</span>`,
          });
        }
      })
    );
    this.getPaymentOptions();
    this.util.addCssToGlobal('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
    this.util.addCssToGlobal('https://api.fontshare.com/v2/css?f[]=sentient@700&display=swap');
    this.setConfig({
      inputAppearance: 'outline',
      cardTheme: 'card-theme-v1',
      donateBtnLabel: 'Proceed to pay'
    });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    const params = new URLSearchParams(window.location.search);
    if (params.has('method')) {
      const op = this.options.find(item => item.order_mode === params.get('method'));
      this.selectedTab = op;
      this.setConfig({ selectedTab: this.selectedTab });
    }
  }

  /**Get the options available for the payment */
  getPaymentOptions() {
    this.subs.push(
      this.paymentV2.paymentOptions.subscribe((data) => {
        if (data) {
          if (this.util.isMobile()) {
            delete data.options.PAYTM;
          }
          this.paymentOptions = data;
          this.paymentOptions.options.TOPWALLET = this.setWalltetNames(this.paymentOptions.options.TOPWALLET);
          this.setConfig({ paymentOptions: this.paymentOptions });
          const keys = Object.keys(this.paymentOptions.options);
          this.options = this.tabs.filter(item => keys.includes(item.order_mode));
          this.setDefaultTab();
          this.recommendedOption = this.options.find(item => item.order_mode === this.paymentOptions.options.RECOMMENDED);
          if (!this.paymentV2.isDonorTypeEventSent) {
            this.paymentV2.isDonorTypeEventSent = true;
            this.paymentV2.donorTypeEvent(this.config.fundraiser, this.paymentV2.paymentConfig.getValue().cart, this.config.user);
          }
        }
      })
    );
  }

  setDefaultTab() {
    const op = this.setPreviouslyUsedOptions();
    if (!this.util.isMobile()) {
      this.setOption(op);
    } else {
      this.router.navigate([], { queryParams: { payment: 'options' }, queryParamsHandling: 'merge' });
    }
    this.generateUpiLink(op);
  }

  setPreviouslyUsedOptions() {
    let op;
    if (this.config?.isQR?.name === 'UPI' || this.config?.upiMode) {
      op = this.options.find(item => item.order_mode === 'UPI');
    } else if (this.config?.isQR?.name === 'Paytm') {
      op = this.options.find(item => item.order_mode === 'PAYTM');
    } else if (this.actRoute.snapshot.queryParams.st === 'f' && this.config.currency === this.actRoute.snapshot.queryParams?.donated_currency) {
      op = this.options.find(item => item.order_mode === this.actRoute.snapshot.queryParams.last_pay_mode);
    } else if (this.config?.paymentOptions?.options?.PREVIOUSPAYMENTGATEWAY && !this.util.isMobile()) {
      op = this.options.find(item => item.order_mode === 'PREVIOUSPAYMENTGATEWAY');
    } else {
      op = this.options.find(item => item.order_mode === this.config?.paymentOptions?.options?.RECOMMENDED || 'CARD');
    }
    return op;
  }

  setOption(option, viewAll?) {
    this.selectedTab = option;
    this.setConfig({ selectedTab: this.selectedTab });
    const qParams: any = {
      payment: 'options', method: option.order_mode
    }
    if (option.order_mode.match('NB|WALLET') && viewAll) {
      qParams.method_type = 'other'
    }
    this.router.navigate([], { queryParams: qParams, queryParamsHandling: 'merge' });
    this.generateUpiQr();
    if (this.config && this.config.cart) {
      this.paymentV2.gtmEventForOrder({
        iso_currency: this.config.currency,
        payment_mode: option.order_mode,
        donated_amount: this.config.cart.donated_amount,
        tip_amount_inr: this.config.cart.tip_amount_inr
      }, 1, this.config.fundraiser);
    }
  }

  viewAll(mode) {
    const op = this.options.find(item => item.order_mode === mode);
    this.setOption(op, true);
  }

  onVpaSubmitButton() {
    this.config.selectedTab = this.options.find(item => item.order_mode === 'UPI');
    this.paymentV2.pledgeBtn.next('upi');
  }

  setWalltetNames(wallets) {
    if (wallets) {
      Object.keys(wallets).forEach(key => wallets[key] = wallets[key].split(' ')[0]);
      return wallets;
    }
  }

  generateUpiLink(option) {
    if (this.util.isMobile() && this.config?.upiMode) {
      this.router.navigate([], { queryParams: { payment: 'options', method: option.order_mode }, queryParamsHandling: 'merge' });
      this.setOption(option);
      if (this.config?.upiMode?.value !== 'OTHER' && this.util.getMobileOperatingSystem() !== 'iOS') {
        this.submit({
          mode: this.config.upiMode.mode,
          mode_value: this.config.upiMode.value
        });
      }
    }
  }

  generateUpiQr() {
    if (!this.util.isMobile() && this.selectedTab.name === 'upi' && !this.paymentV2.upiQrCode.generated) {
      this.qrGenerated = true;
      this.submit({
        mode: 'UPI',
        mode_value: 'DESKTOPQR'
      });
    }
    if (!this.util.isMobile() && this.selectedTab.name === 'paytm' && !this.paymentV2.paytmQrCode.generated) {
      this.qrGenerated = true;
      this.submit({
        mode: 'PAYTM',
        mode_value: 'DESKTOPQR',
      });
    }
  }

  async submit(data) {
    if (this.paymentV2.isOrderLoading) {
      return;
    }
    this.submitData = data;
    this.vars.event_info.info_1 = `${JSON.stringify(this.config.paymentDetails.slabs)}/${this.config.cart.donated_amount}`;
    Object.assign(data, {
      ct: this.config.fundraiser.custom_tag,
      origin: this.config.origin,
      options: this.config.paymentOptions,
      fundraiser: this.config.fundraiser,
      cart: this.config.cart,
      user: this.config.user,
    });
    await this.paymentV2.createOrder(data);
  }

  setConfig(data: IPaymentSipConfig) {
    this.config = { ...this.config, ...data, ...this.inputs };
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
    this.paymentV2.paymentOptions.next(null);
    this.paymentV2.paymentConfig.next(null);
  }

}
